import { Routes, Route, useNavigate } from "react-router-dom";
// Material-UI imports
import Grid from "@mui/material/Grid";
import React, { useEffect } from "react";

// MSAL imports
import { MsalProvider, useIsAuthenticated } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";

// Sample app imports
import { PageLayout } from "./ui-components/PageLayout";
import { Home } from "./pages/Home";
import {MaterialReservation} from './pages/MaterialReservation/MaterialReservation'
import { SRTomzettenFCP } from "./pages/SRTomzettenFCP/SRTomzettenFCP";
import SRTGenerator from "./pages/SRTGenerator/SRTGenerator";
import UrenSchrijven from "./pages/UrenSchrijven/UrenSchrijven";
import { Profile } from "./pages/Profile";
import { Logout } from "./pages/Logout";
// Class-based equivalents of "Profile" component
import { ProfileWithMsal } from "./pages/ProfileWithMsal";
import { ProfileRawContext } from "./pages/ProfileRawContext";
import { ProfileUseMsalAuthenticationHook } from "./pages/ProfileUseMsalAuthenticationHook";
import { Toaster } from 'react-hot-toast';
import "./styles/App.css";
import { startTokenRefresh, stopTokenRefresh } from "./utils/tokenRefresh";

function AppContent() {
    const isAuthenticated = useIsAuthenticated();
    
    useEffect(() => {
        if (isAuthenticated) {
            // Start token refresh wanneer gebruiker is ingelogd
            startTokenRefresh();
        } else {
            // Stop token refresh wanneer gebruiker uitlogt
            stopTokenRefresh();
        }
        
        // Cleanup bij unmount
        return () => {
            stopTokenRefresh();
        };
    }, [isAuthenticated]);
    
    return (
        <PageLayout>
            <Grid container justifyContent="center">
                <Pages />
            </Grid>
            <Toaster position="bottom-right" />
        </PageLayout>
    );
}

function Pages() {
    return (
        <Routes>
            <Route path="/profile" element={<Profile />} />
            <Route path="/profileWithMsal" element={<ProfileWithMsal />} />
            <Route path="/profileRawContext" element={<ProfileRawContext />} />
            <Route
                path="/profileUseMsalAuthenticationHook"
                element={<ProfileUseMsalAuthenticationHook />}
            />
            <Route path="/logout" element={<Logout />} />
            <Route path="/" element={<Home />} />
            <Route path="MaterialReservation" element={<MaterialReservation />} />
            <Route path="SRTGenerator" element={<SRTGenerator />} />
            <Route path="SRTomzettenFCP" element={<SRTomzettenFCP/>}/>
            <Route path="UrenSchrijven" element={<UrenSchrijven />} />
        </Routes>
    );
}

export default function App({ pca }) {
    // Configure MSAL to use router's navigate functions
    const navigate = useNavigate();
    const navigationClient = new CustomNavigationClient(navigate);
    pca.setNavigationClient(navigationClient);
    
    return (
        <MsalProvider instance={pca}>
            <AppContent />
        </MsalProvider>
    );
}